import React from 'react'
import Header from '../_components/common/Header'
import Index from '../_components/ManageAddOn/Index'
import '../_css/TeacherManagement.css'
import '../_css/ManageAddOn.css'

const ManageAddOn = () => {
  return (
    <div className='page-main'>
        <Header name = {["Add On Management"]} />
        <Index />
    </div>
  )
}

export default ManageAddOn